import { useFormContext } from 'react-hook-form';

import { useTranslation } from 'react-i18next';

import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';

const InputDescriptionForm = ({
  name,
  className = '',
  placeholder,
  label,
  isRequired = false,
  minLength = 3,
  maxLength = 500,
  isDisabled = false,
  description,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation('translation', { keyPrefix: 'inputs' });

  const validationRules = {
    minLength: {
      value: minLength,
      message: t('minLength'),
    },
    maxLength: {
      value: maxLength,
      message: t('maxLength'),
    },
  };

  if (isRequired) {
    validationRules.required = t('required');
  }
  return (
    <div className={`${className}`}>
      <FormField
        name={name}
        control={control}
        rules={validationRules}
        disabled={isDisabled}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{label}</FormLabel>
            <FormControl>
              <Textarea
                error={errors[name]}
                disabled={isDisabled}
                placeholder={placeholder}
                {...field}
              />
            </FormControl>
            {description ? <FormDescription>{description}</FormDescription> : null}
            {errors[name] && (
              <div className='d-flex align-items-center error-content'>
                <i className='fas fa-exclamation-triangle text-danger mr-2'></i>
                <p className='text-danger p-0 m-0'>{errors[name].message}</p>
              </div>
            )}
          </FormItem>
        )}
      />
    </div>
  );
};

export default InputDescriptionForm;
